module.exports = __webpack_public_path__ + "static/media/dryer.e9b90ab2.svg";